export default "__VITE_PUBLIC_ASSET__1e082e31__"